import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_serializableAnnotations1rie2dpj7h2ce as get_serializableAnnotations,
  StringValue3s88kmb638dp as StringValue,
  IntValue1zne6ymw597q as IntValue,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/VirtualType.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var RenderContextClass;
function RenderContext() {
  if (RenderContextClass === VOID) {
    class $ {
      constructor(serializer, fieldAnnotations) {
        fieldAnnotations = fieldAnnotations === VOID ? emptyList() : fieldAnnotations;
        this.serializer_1 = serializer;
        this.fieldAnnotations_1 = fieldAnnotations;
      }
      get_typeAnnotations_tp6ee7_k$() {
        return get_serializableAnnotations(this.serializer_1);
      }
      get_allAnnotations_5zk630_k$() {
        return plus(this.fieldAnnotations_1, this.get_typeAnnotations_tp6ee7_k$());
      }
      hasAnnotation_cpsd4h_k$(fqn) {
        var tmp0 = this.get_allAnnotations_5zk630_k$();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.fqn_1 === fqn) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      annotation_buaui3_k$(fqn) {
        var tmp0 = this.get_allAnnotations_5zk630_k$();
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.fqn_1 === fqn) {
              tmp$ret$0 = element;
              break $l$block;
            }
          }
          tmp$ret$0 = null;
        }
        return tmp$ret$0;
      }
      annotationString_m8pucg_k$(fqn, param) {
        var tmp0_safe_receiver = this.annotation_buaui3_k$(fqn);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.values_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_wei43m_k$(param);
        var tmp;
        if (tmp2_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = tmp2_safe_receiver instanceof StringValue() ? tmp2_safe_receiver : null;
        }
        var tmp3_safe_receiver = tmp;
        return tmp3_safe_receiver == null ? null : tmp3_safe_receiver.value_1;
      }
      annotationInt_scjdog_k$(fqn, param) {
        var tmp0_safe_receiver = this.annotation_buaui3_k$(fqn);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.values_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_wei43m_k$(param);
        var tmp;
        if (tmp2_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = tmp2_safe_receiver instanceof IntValue() ? tmp2_safe_receiver : null;
        }
        var tmp3_safe_receiver = tmp;
        return tmp3_safe_receiver == null ? null : tmp3_safe_receiver.value_1;
      }
      toString() {
        return 'RenderContext(serializer=' + toString(this.serializer_1) + ', fieldAnnotations=' + toString(this.fieldAnnotations_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.serializer_1);
        result = imul(result, 31) + hashCode(this.fieldAnnotations_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RenderContext()))
          return false;
        if (!equals(this.serializer_1, other.serializer_1))
          return false;
        if (!equals(this.fieldAnnotations_1, other.fieldAnnotations_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RenderContext');
    RenderContextClass = $;
  }
  return RenderContextClass;
}
//region block: exports
export {
  RenderContext as RenderContextxikz99gtpuie,
};
//endregion

//# sourceMappingURL=RenderContext.mjs.map
